<ion-content>
    <div class="mapcontainer">
        <div *ngIf="(gmapsApiLoaded | async) === true" style="height: 100%; width: 100%;">
            <google-map [attr.data-id]="'away-google-map'" #googlemap id="googlemap" height="100%" width="100%" [options]="{ mapTypeControl: false, fullscreenControl: false }" [zoom]="_mapinfo.zoom" [center]="_mapinfo.position">
                <map-marker [attr.data-id]="'away-google-marker'" *ngFor="let marker of _mapinfo.markers" [position]="marker.position" [options]="marker.options"></map-marker>
            </google-map>    
        </div>
    </div>
    <div class="faraway">
        <ion-item lines="none">
            <ion-label>
                {{tr('@far_away_title')}}<br/>
                <span class="small">{{tr('@far_away_message', [ Distance ])}}</span>
            </ion-label>
        </ion-item>
        <div class="form-buttons">
            <ion-button [attr.data-id]="'away-close-button'" expand="block" (click)="OnClose()">
                {{tr('@far_away_close')}}
            </ion-button>    
        </div>
    </div>
</ion-content>
